const toSpan = (value) => Math.max(parseInt(String(value), 10) || 1, 1);
const hasSpans = (rows) => (rows || []).some(({
  cells = []
}) => cells.some(({
  colspan,
  rowspan
}) => toSpan(colspan) > 1 || toSpan(rowspan) > 1));
const hasBodyRowspan = (rows) => (rows || []).some(({
  cells = []
}) => cells.some(({
  rowspan
}) => toSpan(rowspan) > 1));
function placeCells(rows) {
  const taken = [];
  return (rows || []).map(({
    cells = []
  }, row) => {
    let col = 0;
    return cells.map((cell) => {
      var _a;
      while ((_a = taken[row]) == null ? void 0 : _a[col]) {
        col += 1;
      }
      const colspan = toSpan(cell.colspan);
      const rowspan = toSpan(cell.rowspan);
      for (let r = row; r < row + rowspan; r += 1) {
        taken[r] = taken[r] || [];
        for (let c = col; c < col + colspan; c += 1) {
          taken[r][c] = true;
        }
      }
      const placed = {
        row,
        col,
        colspan,
        rowspan
      };
      col += colspan;
      return placed;
    });
  });
}
function getCellAlignments({
  head,
  body
}) {
  var _a, _b;
  const templateRows = (body == null ? void 0 : body.length) ? body : head;
  const columns = [];
  const template = ((_a = templateRows == null ? void 0 : templateRows[0]) == null ? void 0 : _a.cells) ?? [];
  (_b = placeCells(templateRows == null ? void 0 : templateRows.slice(0, 1))[0]) == null ? void 0 : _b.forEach(({
    col,
    colspan
  }, i) => {
    var _a2;
    for (let c = col; c < col + colspan; c += 1) {
      columns[c] = ((_a2 = template[i]) == null ? void 0 : _a2.align) || "left";
    }
  });
  const resolve = (rows) => placeCells(rows).map((row, r) => row.map(({
    col
  }, c) => rows[r].cells[c].align || columns[col] || "start"));
  return {
    head: resolve(head),
    body: resolve(body)
  };
}
const overlapsColumns = (a, b) => a.col < b.col + b.colspan && b.col < a.col + a.colspan;
const overlapsRows = (a, b) => a.row < b.row + b.rowspan && b.row < a.row + a.rowspan;
const joinIds = (cells) => cells.map(({
  id
}) => id).join(" ") || void 0;
function getHeaderAssociations({
  head: headRows,
  body: bodyRows
}, idPrefix) {
  const head = headRows || [];
  const body = bodyRows || [];
  if (head.length < 2 && !hasSpans(head) && !hasSpans(body)) {
    return null;
  }
  const withIds = (section, rows) => placeCells(rows).map((row, r) => row.map((cell, c) => ({
    ...cell,
    id: `${idPrefix}-${section}-${r}-${c}`,
    isHeader: section === "head" || rows[r].cells[c].tag === "th"
  })));
  const headCells = withIds("head", head);
  const bodyCells = withIds("body", body);
  const columnHeaders = headCells.flat();
  const rowHeaders = bodyCells.flat().filter(({
    isHeader
  }) => isHeader);
  return {
    head: headCells.map((row) => row.map((cell) => ({
      id: cell.id,
      headers: joinIds(columnHeaders.filter((h) => h.row < cell.row && overlapsColumns(h, cell)))
    }))),
    body: bodyCells.map((row) => row.map((cell) => ({
      id: cell.isHeader ? cell.id : void 0,
      headers: joinIds([...columnHeaders.filter((h) => overlapsColumns(h, cell)), ...rowHeaders.filter((h) => h !== cell && h.col < cell.col && overlapsRows(h, cell))])
    })))
  };
}
export {
  getCellAlignments,
  getHeaderAssociations,
  hasBodyRowspan,
  hasSpans,
  placeCells,
  toSpan
};
